import React from 'react'
import './FloatingMessage.css'

const FloatingMessageUI = ({ errorList, success }) =>
  <React.Fragment>
    {
      errorList && errorList.length > 0 &&
      <div className='w_f_error_msg'>
        {
          errorList.map((error, i) =>
            <p key={i}>{error.message}</p>
          )
        }
      </div>
    }
    {
      success &&
      <div className='w_f_success_msg'>
        <p>{success}</p>
      </div>
    }
  </React.Fragment>

export default FloatingMessageUI
